import React from "react";
import { Link } from "react-router-dom";
import { footerColumns } from "../routes";

const COLUMN_ORDER: ("Product" | "For" | "Compare" | "Company" | "Legal")[] = [
  "Product",
  "For",
  "Compare",
  "Company",
  "Legal",
];

const Footer: React.FC = () => {
  const cols = footerColumns();
  const year = new Date().getFullYear();

  return (
    <footer
      className="bg-coffee-900 text-cream-50 border-t border-coffee-800"
      role="contentinfo"
    >
      <div className="max-w-container mx-auto px-6 sm:px-8 lg:px-12 py-20">
        {/* Manifesto + sitemap */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Link to="/" className="inline-flex items-center gap-3 mb-6">
              <span className="font-display text-2xl text-cream-50 tracking-tight">
                WhoBrew<span className="text-accent-400">.</span>
              </span>
            </Link>
            <p className="font-display italic text-2xl text-cream-100 leading-snug max-w-md">
              Made for the people who actually meet people.
            </p>
            <p className="mt-6 text-body-sm text-cream-200 max-w-sm">
              An NFC and digital business card built for the way work happens now.
              One link, every detail. Update once, never reprint.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8">
            {COLUMN_ORDER.map((column) => {
              const list = cols[column];
              if (!list || !list.length) return null;
              return (
                <div key={column}>
                  <h4 className="font-mono text-eyebrow uppercase text-cream-200 mb-4">
                    {column}
                  </h4>
                  <ul className="space-y-2.5">
                    {list.map((r) => (
                      <li key={r.path}>
                        <Link
                          to={r.path}
                          className="text-body-sm text-cream-50/80 hover:text-cream-50 transition-colors"
                        >
                          {r.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>

        {/* Hairline + colophon */}
        <div className="mt-16 pt-6 border-t border-coffee-700 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
          <p className="font-mono text-caption text-cream-200">
            © {year} WhoBrew, LLC. All rights reserved.
          </p>
          <p className="font-mono text-caption text-cream-200">
            Brewed in the United States.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
